import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47ffb860"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "mainTop",
  class: "main_top"
}
const _hoisted_2 = { class: "main_title" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 지분 거래 내역 ")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "row space-between" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bold" }, " 거래내역 ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "slide_down",
  src: "/assets/icon/btn_down_small.png",
  srcset: "/assets/icon/btn_down_small@2x.png 2x,/assets/icon/btn_down_small@3x.png 3x"
}, null, -1))
const _hoisted_9 = {
  class: "empty_box blue_bg",
  style: {"background-image":"url('/assets/image/purple_bg_b.png')"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box_title" }, " 거래 내역이 없습니다. ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box_info" }, " 매력적인 스타트업의 주주가 되어보세요! ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "angel_man",
    src: "/assets/image/richie.png"
  })
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "인기 거래 회사 보러가기 >", -1))
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "content" }
const _hoisted_16 = { class: "row space-between" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bold" }, " 거래내역 ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "slide_down",
  src: "/assets/icon/btn_down_small.png",
  srcset: "/assets/icon/btn_down_small@2x.png 2x,/assets/icon/btn_down_small@3x.png 3x"
}, null, -1))
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "dealInfo_left" }
const _hoisted_21 = { class: "deallogo" }
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_24 = { class: "dealInfo_right" }
const _hoisted_25 = { class: "space-between" }
const _hoisted_26 = { class: "partnership_title" }
const _hoisted_27 = { class: "deal_title deal_price_info" }
const _hoisted_28 = { class: "bold" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_30 = { class: "deal_subinfo space-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_popular_share_transaction_modal = _resolveComponent("popular-share-transaction-modal")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                class: "arrow_b",
                src: "/assets/icon/btn_back.png",
                srcset: "/assets/icon/btn_back@2x.png 2x,/assets/icon/btn_back@3x.png 3x",
                onClick: _cache[0] || (_cache[0] = () => {
              _ctx.$clickTrackEvent({'clickArea':'헤더', 'clickContent':'뒤로가기', clickScreen: _ctx.clickScreen});
              _ctx.route.go(-1)
            })
              }),
              _createVNode(_component_ag_text, {
                typography: "tit18b",
                px: "30px"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ])
          ]),
          (!(_ctx.stakeHistory && _ctx.stakeHistory.length))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("div", {
                      class: "sort",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'거래내역', 'clickContent':'보기옵션', clickScreen: _ctx.clickScreen});_ctx.createModal('filter')})
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.viewOption) + " · " + _toDisplayString(_ctx.viewType), 1),
                      _hoisted_8
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _hoisted_11,
                    _hoisted_12,
                    _createElementVNode("button", {
                      class: "ion-activatable ripple-parent box_btn",
                      onClick: _cache[2] || (_cache[2] = () => {
                _ctx.$clickTrackEvent({'clickArea':'지분 거래 내역이 없습니다', 'clickContent':'인기 거래 회사 보러가기', clickScreen: _ctx.clickScreen});
                _ctx.viewShareTransactionOpen = true
              })
                    }, [
                      _hoisted_13,
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ]),
                    _createVNode(_component_popular_share_transaction_modal, {
                      "model-value": _ctx.viewShareTransactionOpen,
                      onCompanyClick: _cache[3] || (_cache[3] = ($event) => _ctx.useCompanyModal($event)),
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = (value) => _ctx.viewShareTransactionOpen = value)
                    }, null, 8, ["model-value"])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", {
                      class: "sort",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'거래내역', 'clickContent':'보기옵션', clickScreen: _ctx.clickScreen});_ctx.createModal('filter')})
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.viewOption) + " · " + _toDisplayString(_ctx.viewType), 1),
                      _hoisted_18
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_ctx.sortedStakeHistory), (key) => {
                    return (_openBlock(), _createBlock(_component_ag_box_s, {
                      key: key[0],
                      css: {mb:'32px'}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_box_s, { css: {color:'skyPurple1', typography:'text14r'} }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(key[0]), 1)
                          ]),
                          _: 2
                        }, 1024),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(key[1], (stake) => {
                          return _withDirectives((_openBlock(), _createElementBlock("div", {
                            key: stake.createAt,
                            class: "dealInfo_box space-between",
                            onClick: ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'거래내역', 'clickContent':`${stake.partnershipName}`, clickScreen: _ctx.clickScreen});_ctx.createModal('info', stake)}
                          }, [
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("img", {
                                  class: "img-responsive img-circle",
                                  src: stake.partnershipLogo
                                }, null, 8, _hoisted_22),
                                _hoisted_23
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, _toDisplayString(stake.partnershipName), 1),
                                _createElementVNode("div", _hoisted_27, [
                                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$filters.currency(_ctx.transactionPrice(stake))), 1),
                                  _hoisted_29
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_30, [
                                _createVNode(_component_ag_text, {
                                  dp: "block",
                                  typography: "main13r",
                                  color: "gray3",
                                  style: {"flex-shrink":"0","max-width":"75px","min-width":"75px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.formattedDate(stake.createAt)), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ag_text, {
                                  typography: "main13r",
                                  color: stake.type === '구매' ? 'primary' : 'mint1'
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(stake.type), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["color"])
                              ])
                            ])
                          ], 8, _hoisted_19)), [
                            [_vShow, _ctx.viewOption.substring(0,2) === stake.type || _ctx.viewOption === '전체']
                          ])
                        }), 128))
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ])
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}